import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CommonIriDisplay from '../../application-core/CommonIriDisplay';
import { globalStyles as styles } from '../style/gstheme';
import withGS from '../withGShoc';

class TaskResourceDisplay extends React.Component {

  render() {

    const { data, classes, defaultLang, graph, components, viewLang, project, projectType } = this.props;
    const { id } = data;
    const isIn = data.inScheme || data.inDataset || data.visibility;
    const componentsList = Array.isArray(isIn) ? isIn : [isIn];

    return (
      <React.Fragment>
        <TableCell data-test="resource" component="td" className={classes.tableCell} style={{ maxWidth: 200 }}>
          <div style={{ paddingTop: 2 }}>
            <CommonIriDisplay
              id={id}
              compact={true}
              components={components}
              projectIRI={project}
              projectType={projectType}
              useIfWorkflow={true}
              handleNotAvailable={true}
              graph={graph}
              viewLang={defaultLang}
              defaultLang={defaultLang} />
          </div>
        </TableCell>
        <TableCell data-test="component" component="td" className={classes.tableCell}>
          <div style={{ paddingTop: 2 }}>
            {componentsList && componentsList.map(component =>
              <CommonIriDisplay
                key={component}
                id={component}
                compact={true}
                projectType={projectType}
                useIfWorkflow={true}
                components={components}
                projectIRI={project}
                handleNotAvailable={true}
                graph={graph}
                viewLang={viewLang}
                defaultLang={defaultLang} />
            )}
          </div>
        </TableCell>
      </React.Fragment>
    );
  }
}

TaskResourceDisplay.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object.isRequired,
  components: PropTypes.array.isRequired,
  projectType: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  viewLang: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(TaskResourceDisplay, ["ALL"], null, {}, true));